import * as React from "react";
import { Tooltip } from "antd";
import { DualColRow } from 'src/components/common/DualColRow/DualColRow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

interface IFormulaDescription {
  title: string;
  descriptiveFormula?: string;
  filledFormula?: string;
  result: string;
}

export function FormulaDescription(props: IFormulaDescription) {
  return (
    <DualColRow 
      title={
        <>
        {props.title}
        
        {props.descriptiveFormula && (
          <Tooltip title={props.descriptiveFormula}>
            <FontAwesomeIcon icon={faQuestionCircle}/>
          </Tooltip>)}
        :
        </>}
    >
      {props.filledFormula ? (
        <Tooltip title={props.filledFormula}>
          {props.result}
        </Tooltip>
      ):
      (props.result)}
     
    </DualColRow>
  );
}

export default FormulaDescription;



// WEBPACK FOOTER //
// ./src/pages/monitor/my-quotes/formula-description/FormulaDescription.tsx